import React from 'react';
import ReactDOM from 'react-dom';
import { Label } from './FormControl'

if (!window.popUpWindow) window.popUpWindow = [];
if (!window.popUpRef) window.popUpRef = [];

const parentClass = window.isTablet ? ' mobile mobilePopup' : ' normalPopup';
var currentScreenY;
class DragContainner extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate() {
    return false;
  }

  componentDidMount() {
    if (window.isTablet)
      window.scrollTo({ top: 0 })
    return;
    if (this.container) {
      this.height = this.container.scrollHeight;

      setTimeout(() => {

        if (window.popUpWindow.length) {
          var y = 0;
          var popObj = window.popUpWindow[window.popUpWindow.length - 1];
          if (currentScreenY) {

            y = (window.innerHeight - this.height) / 2;
            // var bottomLine = currentScreenY + this.height / 2;
            // if (bottomLine > window.innerHeight) y -= (bottomLine - window.innerHeight);
            // popObj.pan(0, y); 
            // popObj.setState({});
          }

          popObj.showContainer({
            paddingTop: `${y}px`
          });
        }

      });
    }

    console.log("DragContainner", this.container);


    console.log("DragContainner timeout", this.height);

  }

  render() {
    return <div
      ref={(input) => {
        if (input)
          this.container = input.firstChild;
      }} {...this.props}>
      {this.props.children}
    </div>
  }
}
export default function (TargetForm, eventHanlders) {


  return class extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        display: this.props.display,
        padding: {
          ...eventHanlders.padding
        },
        x: 0,
        y: 0,
        dragging: false,
      }
      this.isKiosk = this.props.isKiosk || eventHanlders.isKiosk;
      this.disableHotkey = this.props.disableHotkey || eventHanlders.disableHotkey;
      this.title = eventHanlders.title;
      this.style = {};

      if (this.isKiosk) {
        if (eventHanlders.slideIn == "Left") {
          this.animatedClass = "animated fasterx2 slideInLeft";
          this.style.paddingLeft = this.state.padding.left || "0";
          this.style.paddingRight = this.state.padding.right || "50%";

        } else if (eventHanlders.slideIn == "Up") {
          this.animatedClass = "animated fasterx2 slideInUp";
          this.style.position = "fixed";
          this.style.width = "100%";
          this.style.bottom = eventHanlders.bottom || "0";
        }
        else if (eventHanlders.slideIn == "Down") {
          this.animatedClass = "animated fasterx2 slideInDown";
          this.style.paddingLeft = this.state.padding.left || "0";
          this.style.paddingRight = this.state.padding.right || "0";
          this.style.paddingTop = this.state.padding.top || "0";
        }
        else {
          this.animatedClass = "animated fasterx2 slideInRight";
          this.style.paddingLeft = this.state.padding.left || "50%";
          this.style.paddingRight = this.state.padding.right || "0";
        }
      } else {
        //this.pan(0, 55);
        if (eventHanlders.slideIn != "Up") {
          // this.animatedClass = "animated fasterx2 zoomIn";
        }
      }
    }


    closeWindow = () => {

      this.setState({
        display: false, values: {}
      });

      if (this.closeCallback) this.closeCallback();

      window.popUpWindow.pop();

      if (window.isTablet) {
        window.popUpRef.pop();
        if (window.popUpRef.length && window.popUpRef[window.popUpRef.length - 1]) window.popUpRef[window.popUpRef.length - 1].style.display = 'block';

      }

      if (window.popUpWindow.length == 0) {
        document.removeEventListener('keydown', this.keyPress);
        window.rootElement.removeAttribute('style');
        // window.scrollTo(0, this.originScollY);

        if (!this.props.inline)
          document.documentElement.classList.remove(this.scrollControlClass);

      }

    }

    openWindow = (values) => {
      console.log(eventHanlders);
      this.closeCallback = values.closeCallback;
      this.saveCallback = values.saveCallback;

      this.title = values.title || this.title;
      // this.originScollY = window.scrollY;


      if (window.popUpWindow.length == 0) {

        if (!this.props.inline) {

          this.scrollControlClass = document.body.scrollHeight > window.innerHeight ? 'disabledScrollingWithBar' : 'disabledScrolling';

          if (!window.isTablet)
            document.documentElement.classList.add(this.scrollControlClass);
          else {
            window.rootElement.style.display = 'none';
          }
        }
      }

      //this.pan(-this.state.x, -this.state.y + Math.round((values.screenY || 0) / 2));
      this.pan(-this.state.x, -this.state.y);
      currentScreenY = values.screenY || 0;

      if (values.animation)
        this.animatedClass = `animated ${values.animation}`;
      if (values.animation === "zoomIn" && !this.props.inline && !window.isTablet) {

        this.containerStyle = {
          display: 'flex',
          flexDirection: 'column',
          // justifyContent: 'center',
          height: '100vh',
        };
      } else {
        this.containerStyle = {
        };
      }
      // else {
      //   this.animatedClass = "";
      // }

      // this.MoveContainerStyle = {
      //   opacity: 0
      // }

      this.setState({
        display: true,
        values: values,
      });

      setTimeout(() => {
        this.nameInput.focus();
      });


      window.popUpWindow.push(this);

      if (window.isTablet) {
        if (window.popUpRef.length && window.popUpRef[window.popUpRef.length - 1]) window.popUpRef[window.popUpRef.length - 1].style.display = 'none';
        window.popUpRef.push(this.nameInput);
      }

      if (window.popUpWindow.length == 1) {
        document.addEventListener('keydown', this.keyPress);
      }


    }

    keyPress = (e) => {
      //console.log(e);
      //console.log(window.popUpWindowe);
      console.log(eventHanlders);
      if (e.key === "Escape" && !this.disableHotkey) {
        //this.closeWindow();
        if (window.popUpWindow.length) {
          window.popUpWindow[window.popUpWindow.length - 1].closeWindow();
        }
      }
    }

    onDragStart = (e) => {
      const startX = e.clientX;
      const startY = e.clientY;
      this.MoveContainer.classList.add("hideTransform");

      const state = {
        dragging: true,
        startX,
        startY,
      };

      this.setState(state);


      e.stopPropagation()
      e.preventDefault()
    }

    onDragMove = (e) => {

      if (!this.state.dragging) {
        return;
      }

      const x = e.clientX;
      const y = e.clientY;

      // Take the delta where we are minus where we came from.
      const dx = x - this.state.startX;
      const dy = y - this.state.startY;

      this.state.startX = x;
      this.state.startY = y;

      // Pan using the deltas
      this.pan(dx, dy);

      this.setState({});


      e.stopPropagation()
      e.preventDefault()
    }

    pan = (dx, dy) => {
      this.state.x += dx;
      this.state.y += dy;

      this.state.transform = `translate(${this.state.x}px, ${this.state.y}px)`
    }

    showContainer = (styles) => {
      this.MoveContainerStyle = {
        ...styles
      }
      this.setState({}, () => {
        // this.animatedClassActua   = this.animatedClass;
        this.MoveContainerStyle = {
          opacity: 1, ...styles
        }
        this.setState({});
      });
      // Object.assign(this.MoveContainer.style, {
      //    ...styles
      // });
      // Object.assign(this.MoveContainer.style, {
      //   opacity: '1' 
      // });
    }

    hideContainer = () => {
      Object.assign(this.MoveContainer.style, {
        opacity: '0'
      });
    }

    onDragEnd = (e) => {

      this.MoveContainer.classList.remove("hideTransform");
      this.setState({
        dragging: false
      });


      e.stopPropagation()
      e.preventDefault()
    }

    componentDidMount() {

    }

    componentWillUnmount() {
      //Close kiosk popup window which does not close completely
      if (this.isKiosk && window.popUpWindow.length) {
        window.popUpWindow[window.popUpWindow.length - 1].closeWindow();
      }

      // document.documentElement.style.overflow = 'auto';
      if (!this.props.inline)
        document.documentElement.classList.remove(this.scrollControlClass);

      window.rootElement.removeAttribute('style');

    }

    componentDidUpdate(props, prevState) {
      // //console.log('==============');
      // //console.log(`this.state.dragging = ${this.state.dragging}`);
      // //console.log(`prevState.dragging = ${prevState.dragging}`);
      // //console.log('==============');
      if (this.state.dragging && !prevState.dragging) {
        document.addEventListener('mousemove', this.onDragMove)
        document.addEventListener('mouseup', this.onDragEnd)
      } else if (!this.state.dragging && prevState.dragging) {
        document.removeEventListener('mousemove', this.onDragMove)
        document.removeEventListener('mouseup', this.onDragEnd)
      }
    }

    render() {


      return (

        this.state.display ?
          ReactDOM.createPortal(<React.Fragment>
            {!window.isTablet && !this.props.inline &&
              <div className="popupContainerDim animated faster fadeIn" ></div>}

            <div
              ref={(input) => {
                this.nameInput = input;
              }}
              className={"popupContainer" + parentClass}
              tabIndex="-1"
              style={
                {
                  // pointerEvents: 'none',
                  // overflowY: 'auto'
                }
              }
            >


              {this.isKiosk ?
                <div>
                  <div className={this.animatedClass} style={this.style}>

                    <div
                      style={{
                        pointerEvents: 'visible',
                      }} >
                      <TargetForm
                        {...this.props}
                        mode={this.state.values.mode || this.props.mode}
                        fieldAccessControl={this.state.values.fieldAccessControl || this.props.fieldAccessControl}
                        values={this.state.values} closeWindow={this.closeWindow} saveData={(values) => {
                          this.props.saveData(values);
                          this.closeWindow();

                        }} ></TargetForm>
                    </div>
                  </div>
                </div> :

                <div
                  // className={this.animatedClass}

                  style={this.props.autoFit ? {
                    textAlign: 'center',
                    marginTop: '60px',
                  } :
                    {
                      width: this.props.width || '80%',
                      margin: 'auto',
                      ...this.containerStyle
                    }}
                >
                  <div
                    className={(this.animatedClass ? this.animatedClass : '') + (window.isTablet ? ' mobileFixed' : '')}
                    ref={input => this.MoveContainer = input}
                    style={this.props.autoFit ? {
                      // opacity: this.opacity,
                      // marginTop: this.marginTop,
                      touchAction: 'none',
                      pointerEvents: 'visible',
                      transform: this.state.transform,
                      display: 'inline-block',
                      textAlign: 'left',
                      boxShadow: '0px 0px 6px 0px #a4b7c1',
                      ...this.MoveContainerStyle
                    } : {
                      // touchAction: 'none',
                      pointerEvents: 'visible',
                      transform: this.state.transform,
                      display: 'flex',
                      flexDirection: 'column',
                      // ...this.MoveContainerStyle
                    }}
                  >

                    <div className="handle popupWindowTitle"
                      onMouseDown={this.onDragStart}
                    >
                      <Label>{this.title}</Label>
                      <div className='closeIconContainer' onClick={() => {
                        if (this.props.confirmBeforeClose)
                          confirm(this.props.confirmMsg || "Confirm to close this popup?", () => {
                            if (this.props.confirmToCloseCallback)
                              this.props.confirmToCloseCallback();
                            else
                              this.closeWindow();
                          })
                        else
                          this.closeWindow()
                      }} >
                        <span className="fa fa-close pull-right" ></span>
                      </div>
                    </div>

                    <DragContainner className={"popupWindowBody"}
                      ref={(input) => {
                        this.DragContainnerDiv = input;
                      }}>
                      <div>
                        <div className={"popupFormControl"} id={window.isTablet ? "mobile" : ""}>
                          <TargetForm
                            {...this.props}
                            mode={this.state.values.mode || this.props.mode}
                            fieldAccessControl={this.state.values.fieldAccessControl || this.props.fieldAccessControl}
                            values={this.state.values}
                            closeWindow={this.closeWindow}
                            saveCallback={this.saveCallback}
                            saveData={(values) => {
                              this.props.saveData(values);
                              this.closeWindow();
                            }} ></TargetForm>
                        </div>
                      </div>

                    </DragContainner>
                  </div>

                </div>
              }

            </div>


          </React.Fragment >, document.body)
          : null

      );
    }
  };

}




// WEBPACK FOOTER //
// ./src/components/withDraggablePopup.js